import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/* Microsite legal footer (Legal Engine): auction-specific terms + platform
   policies. Stays inside the brand scope — quiet, white-label, no AOS chrome. */
export const MicrositeFooter = ({ organizer, eventId }) => {
  const { t } = useTranslation();
  const links = [
    { to: `/auction-terms/${eventId}`, label: t("legal.auctionTerms"), testid: "microsite-footer-terms" },
    { to: "/legal/privacy", label: t("footer.privacy"), testid: "microsite-footer-privacy" },
    { to: "/legal/cookies", label: t("footer.cookies"), testid: "microsite-footer-cookies" },
    { to: "/legal/terms", label: t("legal.platformTerms"), testid: "microsite-footer-platform" },
  ];
  return (
    <footer className="mt-20 border-t border-black/5" data-testid="microsite-legal-footer">
      <div className="max-w-6xl mx-auto px-6 lg:px-12 py-10 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <p className="text-xs text-[#0A0A0A]/45">
          © {new Date().getFullYear()} {organizer?.name}
        </p>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label={t("legal.footerNav")}>
          {links.map((l) => (
            <Link
              key={l.testid}
              to={l.to}
              data-testid={l.testid}
              className="text-xs text-[#0A0A0A]/55 hover:text-[#0A0A0A] underline-offset-4 hover:underline transition-colors duration-200"
            >
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  );
};
